import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Book = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 12 10"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 2L11 1V8L6 9M6 2L1 1V8L6 9M6 2V9"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Book.displayName = 'Book'

export default Book
